import { FiltersProps } from '@templates/ListPageLayout/Filters'
import useCoursesFilter from '@hooks/useCoursesFilter'

const useThemesFilters = (): FiltersProps => {
  // В табе "Темы" показываются только темы общих курсов, поэтому и в селекте
  // фильтра должны быть только общие курсы, без клиентских.
  const courses = useCoursesFilter('courseChapterThemes.courseChapter.course', {
    isClientCourse: false,
  })

  return [courses]
}

export default useThemesFilters
